import { TButtonOption } from '../../../types/options';
import { isV2 } from '../../../utils/widgetVersion';

/**
 * Normalises button hierarchy for the widget's design version.
 *
 * Liquid glass exists only in the v2 design: a v1 widget carrying 'tertiaryGlass' falls back to 'tertiary'
 * so it does not render liquid-glass over the v1 background.
 */
export const getDesignHierarchy = <T extends TButtonOption['hierarchy'] | string | undefined>(hierarchy: T, version: number | undefined): T =>
    (isV2({ version }) || hierarchy !== 'tertiaryGlass' ? hierarchy : 'tertiary') as T;
